/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TShowQuizModel = IModel<IShowQuizRequest, TShowQuizResponse>;

export interface IShowQuizRequest {
  /** Поддомен **/
  subdomain?: string | null;
}

export type TShowQuizResponse = IShowQuizResponse200 | IShowQuizResponse400;

export interface IShowQuizResponse200 extends IModelResponse<IShowQuizResponse> {
  statusCode: 200;
}

export interface IShowQuizResponse400 extends IModelResponse<IShowQuizResponseError> {
  statusCode: 400;
}

export interface IShowQuizResponse {
  /** Id опросника **/
  quizId?: number | null;
  /** Определяет степень заполнения отпроса или отсутствие активных в данный момент **/
  status: EStatus;
}

export interface IShowQuizResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IShowQuizResponse | IShowQuizResponseError;

export enum EStatus {
  /** Опрос был уже пройден **/
  Completed = 'completed',
  /** Показали thank you сообщение по каким-то причинам - или тех проблемы или опрос прекратился **/
  HustonProblem = 'hustonProblem',
  /** В процессе прохождения опроса **/
  InProgress = 'inProgress',
  /** Нет активных опросов в данный момент **/
  NoActive = 'noActive',
  /** Пользователь явно указал, что не хочет отвечать на опрос **/
  NotToShow = 'notToShow',
  /** Показать опрос **/
  Ok = 'ok',
  /** Получено достаточное количество ответов для анализа **/
  PartiallyCompleted = 'partiallyCompleted',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IShowQuizResponse): TResponse200;
  400(response: IShowQuizResponseError): TResponse400;
}
